// utils/storage.js
import AsyncStorage from '@react-native-async-storage/async-storage';

export const storage = {
  /**
   * Set a string value in AsyncStorage (ensures value is string)
   */
  async setItem(key, value) {
    try {
      const stringValue = value === null || value === undefined ? '' : String(value);
      await AsyncStorage.setItem(key, stringValue);
      return true;
    } catch (error) {
      console.error(`Error setting ${key} in AsyncStorage:`, error);
      return false;
    }
  },

  /**
   * Get a string value from AsyncStorage
   */
  async getItem(key) {
    try {
      return await AsyncStorage.getItem(key);
    } catch (error) {
      console.error(`Error getting ${key} from AsyncStorage:`, error);
      return null;
    }
  },

  /**
   * Set an object in AsyncStorage (automatically stringified)
   */
  async setObject(key, object) {
    try {
      const jsonValue = JSON.stringify(object);
      await AsyncStorage.setItem(key, jsonValue);
      return true;
    } catch (error) {
      console.error(`Error setting object ${key} in AsyncStorage:`, error);
      return false;
    }
  },

  /**
   * Get an object from AsyncStorage (automatically parsed)
   */
  async getObject(key) {
    try {
      const jsonValue = await AsyncStorage.getItem(key);
      return jsonValue != null ? JSON.parse(jsonValue) : null;
    } catch (error) {
      console.error(`Error getting object ${key} from AsyncStorage:`, error);
      return null;
    }
  },

  /**
   * Remove an item from AsyncStorage
   */
  async removeItem(key) {
    try {
      await AsyncStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error(`Error removing ${key} from AsyncStorage:`, error);
      return false;
    }
  },

  /**
   * Remove multiple items from AsyncStorage
   */
  async multiRemove(keys) {
    try {
      await AsyncStorage.multiRemove(keys);
      return true;
    } catch (error) {
      console.error('Error removing multiple keys from AsyncStorage:', error);
      return false;
    }
  },

  /**
   * Get multiple items from AsyncStorage
   */
  async multiGet(keys) {
    try {
      return await AsyncStorage.multiGet(keys);
    } catch (error) {
      console.error('Error getting multiple keys from AsyncStorage:', error);
      return [];
    }
  },

  /**
   * Set multiple items in AsyncStorage
   */
  async multiSet(keyValuePairs) {
    try {
      // Ensure all values are strings
      const stringifiedPairs = keyValuePairs.map(([key, value]) => [
        key,
        value === null || value === undefined ? '' : String(value)
      ]);
      await AsyncStorage.multiSet(stringifiedPairs);
      return true;
    } catch (error) {
      console.error('Error setting multiple keys in AsyncStorage:', error);
      return false;
    }
  },

  /**
   * Clear all AsyncStorage
   */
  async clear() {
    try {
      await AsyncStorage.clear();
      return true;
    } catch (error) {
      console.error('Error clearing AsyncStorage:', error);
      return false;
    }
  },

  /**
   * Get all keys from AsyncStorage
   */
  async getAllKeys() {
    try {
      return await AsyncStorage.getAllKeys();
    } catch (error) {
      console.error('Error getting all keys from AsyncStorage:', error);
      return [];
    }
  }
};